<template>
  <div class="container">
    <div class="header">
      <img src="@/assets/mbImg/logo.png" alt="" />
    </div>
    <div class="swiper">
      <div class="swiper_b">
        <img
          src="https://image.manzu365.com/storage/image/202603/16/PM3n770lmQ9PqsPk7km7U6z4b50yEipDWxF6vnfG.png"
          alt=""
          class="fz"
          ref="fz"
        />
        <template v-if="btnLoading">
          <div class="swiper_b_item" @click="donwnload(1)">
            <img src="@/assets/mbImg/azxz.png" alt="" />
            <div class="download">
              <div class="download_t">安卓下载</div>
              <div class="download_b">Download</div>
            </div>
          </div>
          <div class="swiper_b_item" @click="donwnload(2)">
            <img src="@/assets/mbImg/pgxz.png" alt="" />
            <div class="download">
              <div class="download_t">苹果下载</div>
              <div class="download_b">Download</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="advantage">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/mbImg/btzs.png" alt="" />
        <span>平台核心优势</span>
        <img src="@/assets/mbImg/btzs.png" alt="" />
      </div>
      <div class="advantage_list">
        <div class="advantage_list_item adv_item_1">
          <img src="@/assets/mbImg/hlzfy.png" alt="" />
          <div class="adv_item_r">
            <div class="adv_t">海量真房源，开箱即用</div>
            <div class="adv_des">
              专业 BD 团队实地验房、拍摄、上架。您无
              需扫楼，登录系统即可分销全城优质房源。
            </div>
          </div>
        </div>
        <div class="advantage_list_item adv_item_2">
          <img src="@/assets/mbImg/jzky.png" alt="" />
          <div class="adv_item_r">
            <div class="adv_t">精准客源，免费派单</div>
            <div class="adv_des">
              平台全网推广获取意向客户，专职自动分配
              看房行程。您无需买端口、无需打陌拜电话。
            </div>
          </div>
        </div>
        <div class="advantage_list_item adv_item_3">
          <img src="@/assets/mbImg/yjyj.png" alt="" />
          <div class="adv_item_r">
            <div class="adv_t">佣金月结，准时到账</div>
            <div class="adv_des">
              每月固定结算日，后台可查每一笔佣金进度。 规则透明，绝无克扣。
            </div>
          </div>
        </div>
        <div class="advantage_list_item adv_item_4">
          <img src="@/assets/mbImg/zc.png" alt="" />
          <div class="adv_item_r">
            <div class="adv_t">10 分钟注册，当天开单</div>
            <div class="adv_des">
              App操作极简，无需复杂培训。新人也能快速 匹配房源与客户。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about_us">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/mbImg/btzs.png" alt="" />
        <span>为什么选择我们</span>
        <img src="@/assets/mbImg/btzs.png" alt="" />
      </div>
      <div class="ab_table_data">
        <div class="table_header">
          <div class="table_header_item table_header_l">对比维度</div>
          <div class="table_header_item table_header_c">
            <div>传统中介/门店模式</div>
          </div>
          <div class="table_header_item table_header_r">
            <div>本平台合作模式</div>
          </div>
        </div>
        <div class="table_content">
          <div class="table_content_l">
            <div>房源获取</div>
            <div>客户来源</div>
            <div>工作内容</div>
            <div>佣金结算</div>
            <div>入驻门槛</div>
          </div>
          <div class="table_content_r">
            <div
              class="table_content_r_item"
              v-for="(item, index) in advList"
              :key="index"
            >
              <div class="table_content_r_item_t">
                <div class="item_err">
                  <img src="@/assets/mbImg/dc.png" alt="" />
                  <div>{{ item.dc }}</div>
                </div>
                <div class="item_success">
                  <img src="@/assets/mbImg/dg.png" alt="" />
                  <div>{{ item.dg }}</div>
                </div>
              </div>
              <div class="table_content_r_item_b">
                <div class="item_out">
                  <img src="@/assets/mbImg/dg.png" alt="" />
                  <div>{{ item.sy }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="what_do">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/mbImg/btzs.png" alt="" />
        <span>您需要做什么？</span>
        <img src="@/assets/mbImg/btzs.png" alt="" />
      </div>
      <div class="what_do_list">
        <div class="what_do_list_item what_do_list_item_1">
          <div>
            <div class="what_t">专业带看</div>
            <div class="what_des">按预约时间带客户看房。</div>
          </div>
          <img src="@/assets/mbImg/zydk.png" alt="" />
        </div>
        <div class="what_do_list_item what_do_list_item_2">
          <div>
            <div class="what_t">促成签约</div>
            <div class="what_des">发挥您的销售专长，完成租赁签约。</div>
          </div>
          <img src="@/assets/mbImg/ccqy.png" alt="" />
        </div>
        <div class="what_do_list_item what_do_list_item_3">
          <div>
            <div class="what_t">维护服务</div>
            <div class="what_des">协助客户办理入住，提升满意度。</div>
          </div>
          <img src="@/assets/mbImg/whfw.png" alt="" />
        </div>
      </div>
    </div>
    <div class="franchise">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/mbImg/btzs.png" alt="" />
        <span>入驻加盟</span>
        <img src="@/assets/mbImg/btzs.png" alt="" />
      </div>
      <div class="franchise_l">
        <div class="franchise_l_btn" @click="scrollToTop">立即免费入驻</div>
        <div class="franchise_l_des">
          已有 <span ref="brokerCount">0</span>+ 经纪人加入， 本月人均增收
          <span ref="incomeAmount">¥0.00</span>
        </div>
      </div>
      <div class="franchise_c">
        <img
          src="https://image.manzu365.com/storage/image/202603/16/QgrbWuW9kGps2N02dHYjYYg9DHVTHGTf41u1wLTf.png"
          alt=""
        />
      </div>
      <div class="franchise_r">
        <div class="franchise_r_1">下载APP</div>
        <div class="franchise_r_2">
          <div>填写信息注册成为经纪人</div>
        </div>
        <div class="franchise_r_3">从平台获取房源 信息并分销</div>
        <div class="franchise_r_4">客户签约</div>
        <div class="franchise_r_5">获取佣金</div>
      </div>
    </div>
    <div class="definition">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/mbImg/btzs.png" alt="" />
        <span>基础定义</span>
        <img src="@/assets/mbImg/btzs.png" alt="" />
      </div>
      <div class="definition_table">
        <table class="data-table">
          <thead>
            <tr>
              <th>术语</th>
              <th>定义</th>
              <th>示例</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>
                {{ item.term }}
              </td>
              <td>{{ item.definition }}</td>
              <td>{{ item.example }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="rule rule_t">
        单笔订单佣金 = 月租金 (R) × (佣金比例系数 (K) / 12) × 租期月份 (M)
      </div>
      <div class="rule rule_b">阶梯规则配置表</div>
      <div class="rule_table">
        <div class="rule_table_header">
          <div class="r_h_l">阶梯等级</div>
          <div class="r_h_c">佣金比例 系数 (K)</div>
          <div class="r_h_r">月度总业绩月份 (Sum_M)</div>
        </div>
        <div
          class="rule_table_content"
          v-for="(item, index) in ruleTableData"
          :key="index"
        >
          <div class="r_c_l">{{ item.term }}</div>
          <div class="r_c_r">
            <div class="r_c_r_t">
              <div class="r_c_r_t_l">{{ item.definition }}</div>
              <div class="r_c_r_t_r">{{ item.example }}</div>
            </div>
            <div class="r_c_r_b">{{ item.explain }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="case">
      <div class="case_title wow fadeInUp" ata-wow-delay="0.2s">
        <div class="title">
          <img src="@/assets/mbImg/btzs.png" alt="" />
          <span>成功案例</span>
          <img src="@/assets/mbImg/btzs.png" alt="" />
        </div>
      </div>
      <div class="case_list">
        <div class="case_item" v-for="(item, index) in caseList" :key="index">
          <div
            class="case_item_title"
            :class="{ case_color_active: item.active }"
          >
            {{ item.title }}
          </div>
          <div class="case_line">
            <div class="case_line_t"></div>
            <div class="case_line_b"></div>
          </div>
          <div
            class="case_item_i"
            v-for="(item2, index2) in item.contentList"
            :key="index2"
          >
            <div class="case_item_i_t">{{ item2.title }}</div>
            <div class="case_item_i_b">
              <div v-for="(item3, index3) in item2.content" :key="index3">
                {{ item3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_t">
        <img src="@/assets/mbImg/logo.png" alt="" />
      </div>
      <div class="footer_b">
        <div>广州共生柠萌信息技术有限公司</div>
        <div>联系电话：18030098225</div>
        <div>地址：广州市白云区尖彭路395号1219室</div>
        <div>粤ICP备2021066618号-1</div>
        <!-- <div>
          <a
            target="_blank"
            class="blank"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            >粤ICP备2021066618号-1</a
          >
        </div> -->
      </div>
    </div>
    <mobile-Loading v-if="isLoading" />
  </div>
</template>
<script>
import { infoVersion } from "@/api/index";
import { Toast } from "vant";

export default {
  name: "index",
  data() {
    return {
      isLoading: false,
      androidPath: null,
      btnLoading: true,
      brokerCountAnimated: false, // 经纪人数量是否已执行动画
      incomeAmountAnimated: false, // 收入金额是否已执行动画
      advList: [
        {
          dc: "需自己扫楼、 打电话、维 护业主关系",
          dg: "平台 BD 统 一采集、维 护",
          sy: "获益点：专注带看，节省大量精力",
        },
        {
          dc: "自费买端口、 发传单、打 陌拜电话",
          dg: "平台网推统 一获客、派 单",
          sy: "获益点：获客成本降为 0",
        },
        {
          dc: "找房 + 找客 +  带看 + 签约 + 售后",
          dg: "核心专注： 带看 + 签约",
          sy: "获益点：工作更纯粹，压力更小",
        },
        {
          dc: "周期长（可能 季度结）、扣 点多",
          dg: "月结、规则更 透明",
          sy: "获益点：现金流更稳定",
        },
        {
          dc: "需坐班、交 押金、买社 保",
          dg: "时间自由、无 押金",
          sy: "获益点：兼职/全职均可，灵活度高",
        },
      ],
      tableData: [
        {
          term: "月租金 (R)",
          definition: "租赁合同中约定的每月租金金额",
          example: "5,000 元",
        },
        {
          term: "租期月份 (M)",
          definition: "租赁合同总时长（按月计算）",
          example: "12 个月、6 个月、18 个月",
        },
        {
          term: "单笔佣金 (C_single)",
          definition: "单个订单理论应得佣金",
          example: "见下方公式",
        },
        {
          term: "月度总业绩月份 (Sum_M)",
          definition: "经纪人当月所有已生效订单的租期月份之和",
          example: "订单 A(12 月) + 订单 B(12 月) = 24 月",
        },
        {
          term: "佣金比例系数 (K)",
          definition: "根据 Sum_M 所在阶梯确定的百分比",
          example: "80%、100%、120%",
        },
      ],
      ruleTableData: [
        {
          term: "青铜档",
          definition: "80%",
          example: "Sum_M < 120",
          explain: "解释：基础佣金，相当于标准佣金的 8 折",
        },
        {
          term: "白银档",
          definition: "100%",
          example: "120 ≤ Sum_M < 180",
          explain: "解释：标准佣金，相当于 1 个月租金/年",
        },
        {
          term: "黄金档",
          definition: "120%",
          example: "Sum_M ≥ 180",
          explain: "解释：奖励佣金，相当于标准佣金的 1.2 倍",
        },
      ],
      caseList: [
        {
          title: "案例一：新人经纪人30天成交20单",
          active: false,
          contentList: [
            {
              title: "背景",
              content: [
                "广州自由经纪人李先生，入行仅3个月，缺乏稳定房源渠道。",
              ],
            },
            {
              title: "使用租小六后",
              content: ["通过平台获取真实房源，并快速发布到自己的客户渠道。"],
            },
            {
              title: "成果",
              content: [
                "30天成交20单租赁",
                "平均成交周期缩短40%",
                "月收入突破1.5万元",
              ],
            },
            {
              title: "客户评价",
              content: [
                "以前找房源要打很多电话，现在平台直接就有，效率高很多。",
              ],
            },
          ],
        },
        {
          title: "案例二：经纪人打造稳定客源池",
          active: false,
          contentList: [
            {
              title: "背景",
              content: [
                "深圳独立经纪人王女士，主要依靠朋友圈和熟客成交，客源有限。",
              ],
            },
            {
              title: "使用租小六后",
              content: ["通过平台房源推广与分享功能，持续获取租客咨询。"],
            },
            {
              title: "成果",
              content: [
                "每月稳定 40+租客咨询",
                "成交率提升 3倍",
                "半年累计成交132单",
              ],
            },
            {
              title: "客户评价",
              content: ["房源集中、真实，客户信任度明显更高。"],
            },
          ],
        },
        {
          title: "案例三：团队经纪人协作成交",
          active: false,
          contentList: [
            {
              title: "背景",
              content: ["厦门某经纪团队（5人），房源和客源信息分散。"],
            },
            {
              title: "使用租小六后",
              content: ["统一在平台管理房源并进行协作推广。"],
            },
            {
              title: "成果",
              content: [
                "房源共享率提升 80%",
                "带看效率提升 60%",
                "团队月成交 翻倍",
              ],
            },
            {
              title: "客户评价",
              content: ["平台让房源共享更简单，合作成交更顺畅。"],
            },
          ],
        },
      ],
    };
  },
  mounted() {
    //获取下载链接
    this.getVersion("android", 3);
    //初始化
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();

    this.$nextTick(() => {
      this.handleScrollAnimation();
      window.addEventListener("scroll", this.handleScrollAnimation);
      // 检查数字滚动
      this.checkNumberScroll();
      window.addEventListener("scroll", this.checkNumberScroll);
    });
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScrollAnimation);
    window.removeEventListener("scroll", this.checkNumberScroll);
  },
  methods: {
    donwnload(type) {
      if (type == 1) {
        //安卓
        window.open(this.androidPath);
      } else if (type == 2) {
        //苹果
        window.open("https://testflight.apple.com/join/ZSsZFWZh");
      }
    },
    getVersion(mode, type) {
      this.btnLoading = false;
      let data = {
        mode: mode,
        type: type,
      };
      infoVersion(data)
        .then((res) => {
          if (mode == "android") {
            this.androidPath = res.data.file_path;
          }
        })
        .finally(() => {
          this.btnLoading = true;
        });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 平滑过渡
      });
    },
    handleScrollAnimation() {
      const fzElement = this.$refs.fz;
      if (!fzElement) return;
      const rect = fzElement.getBoundingClientRect();

      const windowHeight = window.innerHeight;
      // 使用更大的缓冲区域，避免在边界附近抖动
      // 当元素顶部进入视口 80% 位置时触发，离开视口上方 20% 时才移除
      const enterThreshold = windowHeight * 0.8; // 进入阈值
      const leaveThreshold = -windowHeight * 0.2; // 离开阈值（元素完全离开视口上方）
      if (rect.top < enterThreshold && rect.bottom > 0) {
        // 进入视口，添加动画类
        if (!fzElement.classList.contains("animate")) {
          fzElement.classList.add("animate");
        }
      } else if (rect.top < leaveThreshold) {
        // 只有当元素完全离开视口上方一段距离后才移除动画类
        if (fzElement.classList.contains("animate")) {
          fzElement.classList.remove("animate");
        }
      }
    },
    checkNumberScroll() {
      const franchiseList = document.querySelector(".franchise");
      if (!franchiseList) return;

      const rect = franchiseList.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 当 franchise_list 进入视口时触发动画（元素顶部到达视口 70% 位置）
      if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
        // 执行数字滚动动画
        if (!this.brokerCountAnimated) {
          this.animateNumber(this.$refs.brokerCount, 0, 1000, 2000);
          this.brokerCountAnimated = true;
        }
        if (!this.incomeAmountAnimated) {
          this.animateMoney(this.$refs.incomeAmount, 0, 12000, 2000);
          this.incomeAmountAnimated = true;
        }
      }
    },
    // 数字滚动动画
    animateNumber(element, start, end, duration, suffix = "") {
      if (!element) return;
      const startTime = performance.now();
      const updateNumber = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 使用 easeOutExpo 缓动函数
        const easeProgress =
          progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

        const current = Math.floor(start + (end - start) * easeProgress);
        element.textContent = current.toLocaleString() + suffix;

        if (progress < 1) {
          requestAnimationFrame(updateNumber);
        }
      };
      requestAnimationFrame(updateNumber);
    },
    // 金额滚动动画
    animateMoney(element, start, end, duration) {
      if (!element) return;
      const startTime = performance.now();
      const updateMoney = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // 使用 easeOutExpo 缓动函数
        const easeProgress =
          progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

        const current = (start + (end - start) * easeProgress).toFixed(2);
        element.textContent =
          "¥" +
          parseFloat(current).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        if (progress < 1) {
          requestAnimationFrame(updateMoney);
        }
      };
      requestAnimationFrame(updateMoney);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../common/css/mobileIndex.scss";
</style>
